// extracted by mini-css-extract-plugin
module.exports = {"inner":"cd01fbf7b5--inner--Geo_p","title":"cd01fbf7b5--title--vH8da","content":"cd01fbf7b5--content--I8qsx","footer":"cd01fbf7b5--footer--mZ5z7"};